import {Component, Input, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {faDownload} from '@fortawesome/free-solid-svg-icons';
import { IrbAgGridExportService } from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service";

@Component({ standalone: false,
  selector: 'irb-com-account-history',
  templateUrl: './com-account-history.component.html',
  styleUrls: ['./com-account-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComAccountHistoryComponent implements OnInit {
  isUiTest = false;
  gridOptions: any;
  grid: any;
  hasServerSideDatasource: boolean = false;
  faDownload = faDownload;
  @Input() accountId: any;

  constructor(private ies: IrbEditorsService, public ges: IrbAgGridExportService) {
  }

  ngOnInit() {
    const colDef: any = this.getColumnDefs();
    let rowIdIteration = -1;
    this.gridOptions = {
      sortModel: [
        {colId: 'createdDate', sort: 'desc'}
      ],
      columnDefs: colDef,
      rowModelType: 'serverSide',
      floatingFilter: false,
      overlayLoadingTemplate: "<div class='loading-spinner'></div>",
      overlayNoRowsTemplate: "No results found.",
      context: {componentParent: this},
      getRowId: (params: any) => {
        rowIdIteration++;
        const rowId = 'RowId' + rowIdIteration;
        return params.data.accountId + rowId;
      },
      onSortChanged: () => {
        if (!this.hasServerSideDatasource) {
          this.grid.api.setGridOption('serverSideDatasource', this.setDatasource());
        }
      }
    };
  }

  private getColumnDefs() {
    return [
      {
        headerName: "Timestamp",
        field: "createdDate",
        cellRenderer: 'cellRendererFormatter',
        cellRendererParams: {type: 'date', format: 'MM/dd/yyyy h:mm a', displayETtext: true},
        minWidth: 150,
        suppressMovable: true
      },
      {
        headerName: "User",
        field: "modifiedBy",
        minWidth: 70,
        cellRenderer: 'cellRendererFormatter',
        suppressMovable: true
      },
      {
        headerName: "Attribute",
        field: "attributeName",
        minWidth: 50,
        cellRenderer: 'cellRendererFormatter',
        suppressMovable: true
      },
      {
        headerName: "Previous Value",
        field: "previousValue",
        minWidth: 70,
        suppressMovable: true,
        valueFormatter: (params: any) => {
          return params.value ? params.value : '-';
        }
      },
      {
        headerName: "Updated Value",
        field: "updatedValue",
        suppressMovable: true,
        valueFormatter: (params: any) => {
          return params.value ? params.value : '-';
        }
      }
    ];
  }

  onGridReady(params: any) {
    this.grid = params;

    if (!this.hasServerSideDatasource) {
      this.grid.api.setGridOption('serverSideDatasource', this.setDatasource());
    }
  }

  setDatasource() {
    this.hasServerSideDatasource = true;
    return {
      getRows: (params: any) => {
        this.ies.getAccountHistory(params, this.accountId).subscribe((response: any) => {
          let gridData: any = Array.isArray(response) ? response : [];
          if (gridData.length === 0) {
            this.grid.api.showNoRowsOverlay();
          } else {
            this.grid.api.hideOverlay();
          }
          params.success({rowData: gridData});
        }, () => {
          this.grid.api.showNoRowsOverlay();
          params.success({ rowData: [] });
        });
      }
    }
  }

  exportHistory() {
    this.ies.exportAccountHistory(this.accountId).subscribe((_res: any) => {
      this.ges.showSuccessMessage();
    },()=>{});
  }
}
